import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";

class MasterLogistikMotorWarnaFilter extends Component {
    discontinueOptions = [
        {
            label: "YES",
            value: true,
        },
        {
            label: "NO",
            value: false,
        },
    ];

    handleSubmit = () => {
        this.props.onSubmit();
    };

    render() {
        return (
            <SimpleModal
                title="Filter"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <SimpleInput
                                id="input_text_filter_id_warna"
                                name="id"
                                label="ID Warna"
                                value={this.props.selectedData.id}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_filter_kode_warna"
                                name="kodeWarna"
                                label="Kode Warna"
                                value={this.props.selectedData.kodeWarna}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_filter_nama_warna_pabrik"
                                name="namaWarnaPabrik"
                                label="Nama Warna Pabrik"
                                value={this.props.selectedData.namaWarnaPabrik}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_filter_nama_warna_komersil"
                                name="namaWarnaKomersil"
                                label="Nama Warna Komersil"
                                value={this.props.selectedData.namaWarnaKomersil}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleInput
                                id="input_text_filter_kode_varian"
                                name="kodeVariant"
                                label="Kode Varian"
                                value={this.props.selectedData.kodeVariant}
                                onChange={({target}) =>
                                    this.props.onValueChange(target.name, target.value)
                                }
                            />
                            <SimpleDDL
                                id="select_options_filter_discontinue"
                                box="search"
                                name="discontinue"
                                label="Discontinue"
                                isClearable={true}
                                value={this.props.selectedData.discontinue}
                                options={this.discontinueOptions}
                                onChange={(value, {name}) => this.props.onValueChange(name, value)}
                            />
                            <FlexView hAlignContent="right">
                                <SimpleButton type="button" secondary onClick={() => this.props.onClearForm()}>
                                    Hapus
                                </SimpleButton>
                                <SimpleButton onClick={this.handleSubmit}>Terapkan</SimpleButton>
                            </FlexView>
                    </ModalContainer>
                }
            />
        );
    }
}

export default MasterLogistikMotorWarnaFilter;